import c from "./lib/createApi";

const defaultUrl = "/v1/external-api";

export default {
  connectedProtocols: c("GET", defaultUrl + "/connected-protocols", true), // [externalApi - 3]
  searchProtocols: c("GET", defaultUrl + "/search-protocols", true), // [externalApi - 4]
  protocolConnect: c("POST", defaultUrl + "/protocol-connect", true), // [externalApi - 5]
  disconnectProtocolList: c("POST", defaultUrl + "/protocols-disconnect", true), // [externalApi - 6]
  protocolDetail: c("GET", defaultUrl + "/protocol-detail", true), // [externalApi - 7]
  connectProcessThumbnail: c("GET", defaultUrl + "/connect-process-thumbnail", true), // [externalApi - 8]
};
